import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import sweetalert from 'sweetalert2'
import "./vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vClickOutside from 'v-click-outside'
import VueLazyload from 'vue-lazyload'
import mainMixin from './Mixins.js'

// Vue.use(Datetime)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'src/error.png',
  loading: 'src/assets/whiteimg.jpg',
  attempt: 1
})
Vue.use(vClickOutside)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.directive('uppercase',
  {
    inserted: function (el, _, vnode) {
      el.addEventListener('input', async function (e) {
        e.target.value = e.target.value.toUpperCase()
        vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
      })
    }
  })
Vue.directive('removeHiddenSpace',
  {
    inserted: function (el, _, vnode) {
      el.addEventListener('input', async function (e) {
        var result = e.target.value
        try {
          result = result.replace(/(​|“|”|‘|’)/gim, "").trim()
          if (result) {
            e.target.value = result

          } else result = '';
        } catch (error) {

        }
        vnode.componentInstance.$emit('input', result)
      })
    }
  })
Vue.prototype.$liffid = window.liffid
Vue.prototype.$liff = window.liff
Vue.prototype.$swal = sweetalert

Vue.config.productionTip = false
Vue.mixin(mainMixin)

new Vue({
  router,
  created() {
    return (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.com/en_US/messenger.Extensions.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'Messenger'));
  },
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
